// tslint:disable max-classes-per-file
export class DeviceSettings {
  public pollingInterval?: any
  public maxRecvKbps?: any
  public maxSendKbps?: any
  public distributionMode?: any
  public scheduled?: { active: boolean; start: number; end: number }

  constructor(maxRecvKbps, maxSendKbps, distributionMode) {
    this.maxRecvKbps = maxRecvKbps
    this.maxSendKbps = maxSendKbps
    this.distributionMode = distributionMode
  }
}

export class DeviceLocation {
  public address: string
  public lat: number
  public lng: number
}
